import PageContainer from "layouts/components/pageContainer";
import { apiMethod } from "api/agencies";
import { routes } from "routes";
import TableComponent from "components/table";

const Agencies = () => {
  const columns = [
    
    {
      title: "Name",
      dataIndex: "name",
      sorter: true,
      dataType: "text",
    },
    { title: "Actions", dataType: "actions", width: 96 },
  ];

  return (
    <PageContainer title="Agencies" route={{ Create: routes.agencies.create! }}>
      <TableComponent
        apiMethod={apiMethod}
        apiKeyNames={{ list: "list" }}
        columns={columns}
        editRoute={routes.agencies.edit}
        deleteMsgTitle="Delete the Agency"
        deleteMsgDescription="Are you sure to delete this Agency?"
      />
    </PageContainer>
  );
};

export default Agencies;
